<template>
  <div class="card border-top-start-radius-0 border-top-end-radius-0 avaliacao-card">
    <div class="card-body" v-if="state.aluno">
      <div class="vomax-info-bar">
        <div class="row align-items-center">
          <div class="col-12 col-md-4 col-sm-6">
            <label class="vomax-field-label"><i class="fas fa-birthday-cake me-1"></i> {{ $t('age') }}</label>
            <input disabled class="form-control form-control-sm vomax-field-input" type="text" v-model="state.age" />
          </div>
          <div class="col-12 col-md-4 col-sm-6">
            <label class="vomax-field-label"><i class="fas fa-running me-1"></i> {{ $t('classification') }}</label>
            <div class="d-flex gap-2 mt-1">
              <div class="vomax-radio-card" :class="{ 'vomax-radio-active': state.classificacao == 'A' }" @click="state.classificacao = 'A'">
                <input
                  class="form-check-input ms-0 vomax-radio"
                  type="radio"
                  name="flexRadioDefault"
                  :checked="state.classificacao == 'A'"
                />
                <label class="form-check-label ms-1">
                  {{ $t('active') }}
                </label>
              </div>
              <div class="vomax-radio-card" :class="{ 'vomax-radio-active': state.classificacao == 'S' }" @click="state.classificacao = 'S'">
                <input
                  class="form-check-input ms-0 vomax-radio"
                  type="radio"
                  name="flexRadioDefault"
                  :checked="state.classificacao == 'S'"
                />
                <label class="form-check-label ms-1">
                  {{ $t('sedentary') }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-4 col-sm-6">
            <label class="vomax-field-label"><i class="fas fa-heartbeat me-1"></i> {{ $t('heartRate') }}</label>
            <input
              disabled
              class="form-control form-control-sm vomax-field-input"
              type="text"
              v-model="frequenciaCardiaca"
            />
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-6 col-lg-4">
          <label class="vomax-field-label"><i class="fas fa-clipboard-list me-1"></i> {{ $t('selectProtocol') }}</label>
          <select class="form-control form-control-sm custom-select vomax-select" v-model="state.protocolo">
            <option value="">{{ $t('selectHere') }}</option>
            <option value="cooper">{{ $t('cooperTest') }}</option>
            <option value="corrida">{{ $t('runTest') }}</option>
            <option value="caminhada">{{ $t('walkTest') }}</option>
          </select>
        </div>
      </div>

      <div class="row" v-if="state.protocolo === 'cooper'">
        <div class="col-12 col-md-6 col-lg-4">
          <label class="form-label mt-2">{{ $t('distanceCoveredKm') }}</label>
          <money3
            v-bind="state.config"
            v-model="state.cooperDistancia"
            class="form-control"
          ></money3>
        </div>
      </div>
      <div class="row" v-if="state.protocolo === 'corrida'">
        <div class="col-12 col-md-6 col-lg-4">
          <label class="form-label mt-2">{{ $t('courseTimeMinSec') }}</label>
          <input
            class="form-control"
            type="text"
            v-maska="'##:##'"
            :placeholder="$t('minSecPlaceholder')"
            v-model="state.corridaTempoPercurso"
          />
        </div>
      </div>
      <div class="row" v-if="state.protocolo === 'caminhada'">
        <div class="col-12 col-md-6 col-lg-4">
          <label class="form-label mt-2">{{ $t('weight') }}</label>
          <input
            class="form-control"
            type="text"
            :placeholder="$t('weight')"
            v-model="state.caminhada.peso"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <label class="form-label mt-2">{{ $t('finalHeartRate') }}</label>
          <input
            class="form-control"
            type="text"
            :placeholder="$t('heartRate')"
            v-model="state.caminhada.frequenciaCardiaca"
          />
        </div>
        <div class="col-12 col-md-6 col-lg-4">
          <label class="form-label mt-2">{{ $t('courseTimeMinSec') }}</label>
          <input
            class="form-control"
            type="text"
            v-maska="'##:##'"
            :placeholder="$t('minSecPlaceholder')"
            v-model="state.caminhada.tempoPercurso"
          />
        </div>
      </div>
      <div v-if="state.protocolo != ''" class="row mt-3">
        <div class="col-12">
          <div class="vomax-resultado-header">
            <i class="fas fa-chart-line me-2"></i>{{ $t('result') }}
          </div>
        </div>
        <div class="col-12 vomax-result-row">
          <label class="me-2">{{ $t('vo2maxObtained') }}</label>
          <span class="vomax-result-value">
            {{ voObtido() }}
          </span>
        </div>
        <div class="col-12 vomax-result-row">
          <label class="me-2">{{ $t('vo2maxPredicted') }}</label>
          <span class="vomax-result-value">
            {{ voPrevisto() }}
          </span>
        </div>
        <div class="col-12 vomax-result-row">
          <label class="me-2">{{ $t('mets') }}</label>
          <span class="vomax-result-value">
            {{ mets() }}
          </span>
        </div>
        <div class="col-12 vomax-result-row">
          <label class="me-2">{{ $t('classification') }}</label>
          <span class="vomax-result-value">
            {{ classificacao() }}
          </span>
        </div>
        <div class="col-12 vomax-result-row">
          <label class="me-2">{{ $t('faiPercent') }}</label>
          <span class="vomax-result-value">
            {{ fai() }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-end mt-3">
          <router-link to="/avaliacao-fisica">
            <button type="button" class="btn bg-gradient-secondary">
              {{ $t('back') }}
            </button>
          </router-link>
          <button type="button" class="ms-3 btn bg-gradient-primary" @click.prevent="salvar">
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onMounted, ref, inject, computed, watch } from 'vue'
import { useStore } from 'vuex'
import composicaoCorporalRepository from '../../../../../services/api/composicaoCorporalRepository'
import { useRouter, useRoute } from 'vue-router'
import ComposiaoCorporalModel from '@/models/composicaoCorporalModel'
import { Money3Component } from 'v-money3'
import alunoRepository from '@/services/api/alunoRepository'
import { voMaxClassificacao } from '@/services/VoMax.service'
import voMaxRepository from '@/services/api/voMaxRepository'

export default {
  components: {
    money3: Money3Component,
  },
  props: {
    avaliacaoIdProp: {
      type: Number,
      default: 0,
    },
  },
  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const swal = inject('$swal')
    const store = useStore()

    onMounted(async () => {
      state.avaliacaoId = props.avaliacaoIdProp
      await buscarDados()
      await buscaDadosAluno()
    })

    const state = reactive({
      id: 0,
      frequenciaCardiaca: 0,
      age: 0,
      classificacao: '',
      protocolo: '',
      avaliacaoId: 0,
      cooperDistancia: '',
      corridaTempoPercurso: '',
      caminhada: {
        peso: '',
        frequenciaCardiaca: '',
        tempoPercurso: '',
      },
      aluno: null,
      config: {
        masked: false,
        prefix: '',
        suffix: '',
        thousands: '.',
        decimal: ',',
        precision: 3,
        disableNegative: false,
        disabled: false,
        min: 0,
        max: null,
        allowBlank: false,
        minimumNumberOfCharacters: 0,
        shouldRound: true,
        focusOnRight: false,
      },
    })

    async function buscaDadosAluno() {
      alunoRepository
        .AlunoGetCurrent()
        .then((response) => {
          // data vem null quando o header student-manager nao resolve um aluno.
          // Antes o codigo seguia e estourava em state.aluno.age.
          if (response.data.success && response.data.data) {
            state.aluno = response.data.data

            // quando ja tiver registro de idade nao faz calculo novo de idade
            if (state.age == 0 && state.aluno.age != null) {
              state.age = state.aluno.age
            }
          }
        })
        .catch((error) => {
          store.commit('SET_SPLASH_SCREEN', false)
          console.error(error)
        })
        .finally(() => {
          store.commit('SET_SPLASH_SCREEN', false)
        })
    }

    async function buscarDados() {
      store.commit('SET_SPLASH_SCREEN', true)
      try {
        if (state.avaliacaoId !== 0) {
          let response = await voMaxRepository.VoMaxGetByAssessmentId(state.avaliacaoId)
          store.commit('SET_SPLASH_SCREEN', false)
          if (response.data.success) {
            if (response.data.data != null) {
              let item = response.data.data

              if (state.age == 0) {
                state.age = item['age']
              }

              state.id = item['id']
              state.classificacao = item['classification']
              state.cooperDistancia = item['cooper']
              state.caminhada.peso = item['walking_weight']
              state.caminhada.frequenciaCardiaca = item['walking_frequency']
              state.caminhada.tempoPercurso = item['walking_time']
              state.corridaTempoPercurso = item['running_time']

              if (state.cooperDistancia) {
                state.protocolo = 'cooper'
              } else if (state.caminhada.peso) {
                state.protocolo = 'caminhada'
              } else {
                state.protocolo = 'corrida '
              }
            }
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    function classificacao() {
      return voMaxClassificacao(state.aluno.sex, state.aluno.age, voObtido())
    }

    function cooper() {
      if (!state.cooperDistancia) return 0
      return (parseInt(state.cooperDistancia.replace('.', '')) - 504) / 45
    }

    function corrida() {
      if (state.corridaTempoPercurso == '' || state.corridaTempoPercurso == null) return 0
      let tempoPercurso = state.corridaTempoPercurso.split(`:`)
      let tempoSegundo = parseInt(tempoPercurso[0] * 60) + parseInt(tempoPercurso[1])
      return (2400 * 12 + 3.5) / tempoSegundo
    }

    function caminhada() {
      if (state.caminhada.tempoPercurso == null) return 0
      let sexo = state.aluno.sex == 'F' ? 1 : 0
      let peso = state.caminhada.peso
      let idade = state.age
      let tempo = state.caminhada.tempoPercurso.split(`:`)
      let tempoPercurso = parseInt(tempo[0] * 60) + parseInt(tempo[1])

      let frequenciaCardiacaFinal = state.caminhada.frequenciaCardiaca

      let response =
        6.952 +
        0.0091 * peso -
        0.0257 * idade +
        0.5955 * sexo -
        0.224 * tempoPercurso -
        0.0115 * frequenciaCardiacaFinal
      return parseFloat(response).toFixed(2)
    }

    const frequenciaCardiaca = computed(() => {
      return 220 - parseInt(state.aluno.age)
    })

    function fai() {
      let response = (voPrevisto() - voObtido()) / voPrevisto()
      return parseFloat(response).toFixed(2)
    }

    function mets() {
      return parseFloat(voObtido() / 3.5).toFixed(2)
    }

    function voObtido() {
      let obtido = 0

      if (state.protocolo == 'cooper') {
        obtido = cooper()
      }

      if (state.protocolo == 'caminhada') {
        obtido = caminhada()
      }

      if (state.protocolo == 'corrida') {
        obtido = corrida()
      }

      obtido = parseFloat(obtido).toFixed(2)

      if (obtido == 'NaN' || obtido == undefined) return 0

      return obtido
    }

    function voPrevisto() {
      let previsto = 0

      if (state.aluno.sex == 'M') {
        if (state.classificacao == 'A') {
          previsto = 69.7 - 0.612 * state.age
        } else {
          previsto = 57.8 - 0.445 * state.age
        }
      } else {
        if (state.classificacao == 'A') {
          previsto = 42.9 - 0.312 * state.age
        } else {
          previsto = 42.3 - 0.356 * state.age
        }
      }

      previsto = parseFloat(previsto).toFixed(2)

      if (previsto == 'NaN' || previsto == undefined) return 0

      return previsto
    }

    function salvar() {
      try {
        let item = []
        item['student_physical_assessment_id'] = state.avaliacaoId
        item['age'] = state.age
        item['classification'] = state.classificacao
        item['cooper'] = state.cooperDistancia
        item['walking_weight'] = state.caminhada.peso
        item['walking_frequency'] = state.caminhada.frequenciaCardiaca
        item['walking_time'] = state.caminhada.tempoPercurso
        item['running_time'] = state.corridaTempoPercurso

        /*console.log(item)
        return*/

        store.commit('SET_SPLASH_SCREEN', true)

        if (state.avaliacaoId == 0 && route.params.id && parseInt(route.params.id) > 0) {
          state.avaliacaoId = parseInt(route.params.id)
        }

        if (state.avaliacaoId == 0) {
          context.emit('salvar', Object.assign({}, item), 'vomax')
        } else {
          let jsonItem = JSON.stringify(item)

          if (state.id == undefined || state.id == 0) {
            voMaxRepository.VoMaxPost(Object.assign({}, item)).then((response) => {
              store.commit('SET_SPLASH_SCREEN', false)

              if (response.data.success) {
                swal({
                  title: 'Vo2',
                  text: 'Vo2 cadastrado com sucesso!',
                  icon: 'success',
                  customClass: {
                    confirmButton: 'btn bg-gradient-success',
                  },
                  buttonsStyling: false,
                })
              }
            })
          } else {
            voMaxRepository.VoMaxPut(state.id, Object.assign({}, item)).then((response) => {
              store.commit('SET_SPLASH_SCREEN', false)

              if (response.data.success) {
                swal({
                  title: 'Vo2',
                  text: 'Vo2 cadastrado com sucesso!',
                  icon: 'success',
                  customClass: {
                    confirmButton: 'btn bg-gradient-success',
                  },
                  buttonsStyling: false,
                })
              }
            })
          }
        }
      } catch (error) {
        store.commit('SET_SPLASH_SCREEN', false)
        console.error(error)
      } finally {
        store.commit('SET_SPLASH_SCREEN', false)
      }
    }

    return {
      state,
      salvar,
      frequenciaCardiaca,
      voObtido,
      voPrevisto,
      fai,
      mets,
      classificacao,
    }
  },
}
</script>

<style scoped>
.avaliacao-card {
  border: 1px solid #d0d5e0;
  border-radius: 0 0 10px 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.vomax-info-bar {
  background: linear-gradient(135deg, #edf0f6 0%, #e4e8f0 100%);
  border-radius: 12px;
  padding: 18px;
  border: 1px solid #c8cedf;
  margin-bottom: 8px;
}
.vomax-field-label {
  font-weight: 600;
  color: #2D3A7C;
  font-size: 0.85rem;
  margin-bottom: 4px;
}
.vomax-field-input {
  border: 2px solid #2D3A7C !important;
  border-radius: 8px !important;
  font-weight: 700;
  color: #344767;
  background: #fff;
}
.vomax-field-input:disabled {
  background: #f4f6f9;
  opacity: 0.9;
}
.vomax-radio-card {
  display: flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 8px;
  border: 2px solid #c8cedf;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
}
.vomax-radio-card:hover {
  border-color: #2D3A7C;
  background: #edf0f6;
}
.vomax-radio-active {
  border-color: #2D3A7C !important;
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%) !important;
}
.vomax-radio-active label {
  color: #fff !important;
  font-weight: 600;
}
.vomax-radio {
  border: 2px solid #2D3A7C !important;
  cursor: pointer;
}
.vomax-radio:checked {
  background-color: #F7941D !important;
  border-color: #F7941D !important;
}
.vomax-select {
  border: 2px solid #2D3A7C !important;
  border-radius: 8px !important;
  font-weight: 600;
  color: #344767;
}
.vomax-select:focus {
  box-shadow: 0 0 0 3px rgba(247, 148, 29, 0.2) !important;
}
.vomax-resultado-header {
  background: linear-gradient(135deg, #2D3A7C 0%, #3B4A8C 100%);
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 12px 18px;
  border-radius: 10px;
  margin-bottom: 12px;
  letter-spacing: 0.3px;
  box-shadow: 0 4px 12px rgba(45, 58, 124, 0.3);
}
.vomax-result-row {
  display: flex;
  align-items: center;
  padding: 12px 14px;
  border-bottom: 1px solid #e8eaf0;
  transition: background 0.15s;
  border-radius: 6px;
  margin-bottom: 2px;
}
.vomax-result-row:nth-child(even) {
  background: #f4f6f9;
}
.vomax-result-row:hover {
  background: #ebeff5;
}
.vomax-result-row label {
  font-weight: 600;
  color: #2D3A7C;
  font-size: 0.88rem;
  min-width: 160px;
}
.vomax-result-value {
  display: inline-block;
  background: #F7941D;
  color: #fff;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 4px 16px;
  border-radius: 8px;
  min-width: 70px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(247, 148, 29, 0.3);
}
</style>
